import {Component} from 'react'
import Loader from 'react-loader-spinner'

import './App.css'

const categoriesList = [
  {id: 'ALL', displayText: 'All'},
  {id: 'STATIC', displayText: 'Static'},
  {id: 'RESPONSIVE', displayText: 'Responsive'},
  {id: 'DYNAMIC', displayText: 'Dynamic'},
  {id: 'REACT', displayText: 'React'},
]

const apiStatusCon = {
  initial: 'INITIAL',
  success: 'SUCCESS',
  failure: 'FAILURE',
  inProgress: 'IN_PROGRESS',
}

class App extends Component {
  state = {
    projectsList: [],
    apiStatus: apiStatusCon.initial,
    selected: categoriesList[0].id,
  }

  componentDidMount() {
    this.getProjects()
  }

  getProjects = async () => {
    this.setState({apiStatus: apiStatusCon.inProgress})
    const {selected} = this.state

    const url = `https://apis.ccbp.in/ps/projects?category=${selected}`
    const options = {
      method: 'GET',
    }
    const res = await fetch(url, options)
    if (res.ok) {
      const data = await res.json()
      const updatedData = data.projects.map(each => ({
        id: each.id,
        name: each.name,
        imageUrl: each.image_url,
      }))
      this.setState({
        projectsList: updatedData,
        apiStatus: apiStatusCon.success,
      })
    } else {
      this.setState({apiStatus: apiStatusCon.failure})
    }
  }

  retry = () => {
    this.getProjects()
  }

  changeSelect = event => {
    this.setState({selected: event.target.value}, this.getProjects)
  }

  renderHeader = () => (
    <div className="nav-con">
      <img
        src="https://assets.ccbp.in/frontend/react-js/projects-showcase/website-logo-img.png"
        alt="website logo"
        className="logo"
      />
    </div>
  )

  renderLoader = () => (
    <div data-testid="loader" className="load">
      <Loader type="ThreeDots" color="#00BFFF" height={50} width={50} />
    </div>
  )

  renderFailure = () => (
    <div className="failure-con">
      <div>
        <img
          src="https://assets.ccbp.in/frontend/react-js/projects-showcase/failure-img.png"
          alt="failure view"
          className="failure-img"
        />
        <h1 className="failure-head">Oops! Something went wrong </h1>
        <p className="failure-para">
          We cannot seem to find the page you are looking for.
        </p>
        <button type="button" onClick={this.retry} className="failure-btn">
          Retry
        </button>
      </div>
    </div>
  )

  renderSuccess = () => {
    const {projectsList} = this.state

    return (
      <div>
        <ul className="projects-list">
          {projectsList.map(each => (
            <li key={each.id} className="project-item">
              <img
                src={each.imageUrl}
                alt={each.name}
                className="project-img"
              />
              <p className="project-para">{each.name}</p>
            </li>
          ))}
        </ul>
      </div>
    )
  }

  renderResult = () => {
    const {apiStatus} = this.state
    switch (apiStatus) {
      case apiStatusCon.inProgress:
        return this.renderLoader()
      case apiStatusCon.failure:
        return this.renderFailure()
      case apiStatusCon.success:
        return this.renderSuccess()
      default:
        return null
    }
  }

  render() {
    const {selected} = this.state

    return (
      <div>
        {this.renderHeader()}
        <div>
          <ul>
            <select
              className="sel"
              value={selected}
              onChange={this.changeSelect}
            >
              {categoriesList.map(each => (
                <option value={each.id} key={each.id}>
                  {each.displayText}
                </option>
              ))}
            </select>
          </ul>
        </div>
        <div>{this.renderResult()}</div>
      </div>
    )
  }
}

export default App
